// extracted by mini-css-extract-plugin
export const wrapper = "education-module--wrapper--2s4j-";
export const title = "education-module--title--1ZXcz";
export const highlighted = "education-module--highlighted--3glF4";